import React from 'react';
import type { LessonTab } from '../types';
import { tabs, routeMap } from '../constants';

interface LessonsPageTabsProps {
    activeTab: LessonTab;
}

export function LessonsPageTabs({ activeTab }: LessonsPageTabsProps) {
    return (
        <div className="mb-6">
            <nav className="flex flex-wrap border-b border-gray-200">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    const tourId =
                        tab.id === 'addTopics'
                            ? 'tab-add-topics'
                            : tab.id === 'create'
                              ? 'tab-create-units'
                              : tab.id === 'review'
                                ? 'tab-review'
                                : tab.id === 'inprogress'
                                  ? 'tab-inprogress'
                                  : tab.id === 'done'
                                    ? 'tab-completed'
                                    : undefined;
                    return (
                        <button
                            key={tab.id}
                            data-tour={tourId}
                            onClick={() => {
                                window.location.hash = `#${routeMap[tab.id]}`;
                            }}
                            className={`flex items-center px-4 py-2.5 text-sm font-medium transition-all border-b-2 whitespace-nowrap mr-2 mb-2 rounded-t-lg ${
                                activeTab === tab.id
                                    ? 'border-action-blue text-action-blue'
                                    : 'border-transparent text-gray-500 hover:text-gray-700'
                            }`}
                        >
                            <Icon size={16} className="mr-2"/>
                            {tab.label}
                        </button>
                    );
                })}
            </nav>
        </div>
    );
}
